import React from "react";

import './style.scss';

const ToggleSwitch = (props) => (
  <label className="toggle-switch">
    <input type="checkbox" {...props} />
    <span className="t-s-slider" />
  </label>
);

export default ToggleSwitch;
